import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

/**
 * Statut global de la cotation externe (lien public ?from=external).
 *
 * Lecture via une route PUBLIQUE (`GET /api/app-settings/external-cotation`,
 * sans token) : un vendeur externe arrivant sur le lien n'est pas toujours
 * authentifié, on utilise donc `axios` brut plutôt que `makeAuthenticatedApiCall`.
 *
 * Défaut `enabled = true` tant que la requête n'a pas répondu (ou en cas
 * d'erreur réseau), pour ne pas afficher par erreur le message "désactivée"
 * sur le flux historique.
 */
interface ExternalCotationStatusResponse {
  success: boolean;
  data: { key: string; enabled: boolean };
}

export const useExternalCotationEnabled = (): { enabled: boolean; isLoading: boolean } => {
  const { data, isLoading } = useQuery({
    queryKey: ['externalCotationStatus'],
    queryFn: async (): Promise<ExternalCotationStatusResponse> => {
      const response = await axios.get<ExternalCotationStatusResponse>(
        '/api/app-settings/external-cotation',
      );
      return response.data;
    },
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });

  // Défaut activé : on ne bloque que si le backend a explicitement répondu false.
  const enabled = data?.data?.enabled ?? true;
  return { enabled, isLoading };
};
